/**
 * VerificationFilter — Toggle for "Verified Only" filter.
 *
 * Story 3.4 — Task 4.4
 */

import { cn } from "../../lib/cn";

type VerificationFilterProps = {
	checked: boolean;
	onChange: (checked: boolean) => void;
};

export function VerificationFilter({ checked, onChange }: VerificationFilterProps) {
	return (
		<label
			htmlFor="verified-only"
			className={cn(
				"inline-flex items-center gap-2 cursor-pointer select-none",
				"px-3 py-1.5 rounded-full text-xs font-medium transition-colors",
				checked
					? "bg-blue-100 text-blue-700"
					: "bg-pastel-light-gray text-pastel-gray hover:bg-pastel-border"
			)}
		>
			<input
				id="verified-only"
				type="checkbox"
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
				className="sr-only"
			/>
			<svg
				className={cn("h-3.5 w-3.5", checked ? "text-blue-600" : "text-pastel-gray")}
				viewBox="0 0 20 20"
				fill="currentColor"
				aria-hidden="true"
			>
				<path
					fillRule="evenodd"
					d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
					clipRule="evenodd"
				/>
			</svg>
			Verified Only
		</label>
	);
}
